import Gallery from '../Gallery/Gallery';
import './CardGallery.scss';

const initialized = new WeakSet();

const io = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const el = entry.target;
      if (initialized.has(el)) return;

      const images = JSON.parse(el.dataset.images);

      if (!el.id) {
        el.id = `gallery-${Math.random().toString(36).slice(2)}`;
      }

      new Gallery(images, `#${el.id}`);

      initialized.add(el);
      observer.unobserve(el);
    });
  },
  {
    rootMargin: '100px',
  }
);

export const initCardGalleries = () => {
  document.querySelectorAll('[data-gallery]').forEach(el => {
    if (initialized.has(el)) return;
    io.observe(el);
  });
};

initCardGalleries();
